import { isBefore, format } from 'date-fns'

export function isValidDate(d: unknown) {
  return d instanceof Date && !isNaN(d as any)
}

export function isActiveTrialPeriod(trialPeriod: string): boolean {
  switch (trialPeriod) {
    case 'yearEnd2025':
      const currentDate = new Date(format(new Date(), 'yyyy-MM-dd'));
      const comparedDate = new Date(format(new Date('2027-01-01T02:00:00'), 'yyyy-MM-dd'));
      return isBefore(currentDate, comparedDate)
    default:
      return false
  }
}
